/*
*
* Script for fixed navigation
*
*/

export const scrollFlag = () => {
    const nav = document.querySelector(".header");
    const header = document.querySelector("header");
    const headerSimple = document.querySelector(".header--simple");

    if(headerSimple && header) {
        if (window.pageYOffset > 150) {
            headerSimple.classList.add("--scrolled");
            header.classList.add("--scrolled");
        } else {
            headerSimple.classList.remove("--scrolled");
            header.classList.remove("--scrolled");
        }

    }

    if (!nav || !header) return;

    if (window.pageYOffset > 142) {
        nav.classList.add("--scrolled");
        header.classList.add("--scrolled");
    } else {
        nav.classList.remove("--scrolled");
        header.classList.remove("--scrolled");
    }
}